import localforage from "localforage";

const PWA_HAS_BEEN_OPENED_KEY = "pwa.hasBeenOpened";

export const isPwa = (): boolean => {
  return (
    (navigator as any).standalone ||
    window.matchMedia("(display-mode: standalone)").matches
  );
};

export const isFirstTimeOpeningPwa = async () => {
  const hasBeenOpened = await localforage.getItem(PWA_HAS_BEEN_OPENED_KEY);
  return !Boolean(hasBeenOpened);
};

// NOTE: in it's current form, this can only be used once
export const onFirstPWAOpen = async (handler: () => void) => {
  if (isPwa() && (await isFirstTimeOpeningPwa())) {
    handler();
    localforage.setItem(PWA_HAS_BEEN_OPENED_KEY, true);
  }
};
